/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1CourseCourseidChannels201,
  PostApiV1CourseCourseidChannels400,
  PostApiV1CourseCourseidChannels401,
  PostApiV1CourseCourseidChannels404,
  PostApiV1CourseCourseidChannels500,
  PostApiV1CourseCourseidChannelsMutationRequest,
  PostApiV1CourseCourseidChannelsMutationResponse,
  PostApiV1CourseCourseidChannelsPathParams,
} from "../../types/courseChannelsController/PostApiV1CourseCourseidChannels.ts";
import { channelDetailViewModelSchema } from "../channelDetailViewModelSchema.ts";
import { upsertChannelRequestViewModelSchema } from "../upsertChannelRequestViewModelSchema.ts";

export const postApiV1CourseCourseidChannelsPathParamsSchema = z.object({
  courseId: z.coerce.number().int(),
}) as unknown as ToZod<PostApiV1CourseCourseidChannelsPathParams>;

/**
 * @description (Created) Objeto criado com sucesso.
 */
export const postApiV1CourseCourseidChannels201Schema = z.lazy(
  () => channelDetailViewModelSchema,
) as unknown as ToZod<PostApiV1CourseCourseidChannels201>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1CourseCourseidChannels400Schema =
  z.any() as unknown as ToZod<PostApiV1CourseCourseidChannels400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1CourseCourseidChannels401Schema =
  z.any() as unknown as ToZod<PostApiV1CourseCourseidChannels401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const postApiV1CourseCourseidChannels404Schema =
  z.any() as unknown as ToZod<PostApiV1CourseCourseidChannels404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1CourseCourseidChannels500Schema =
  z.any() as unknown as ToZod<PostApiV1CourseCourseidChannels500>;

export const postApiV1CourseCourseidChannelsMutationRequestSchema = z.lazy(
  () => upsertChannelRequestViewModelSchema,
) as unknown as ToZod<PostApiV1CourseCourseidChannelsMutationRequest>;

export const postApiV1CourseCourseidChannelsMutationResponseSchema = z.lazy(
  () => postApiV1CourseCourseidChannels201Schema,
) as unknown as ToZod<PostApiV1CourseCourseidChannelsMutationResponse>;
